import OpenInNewIcon from '@mui/icons-material/OpenInNew'

export default function Footer() {
  return (
    <footer className='px-4 pb-8 space-y-4'>
      <div className='space-y-2 text-center'>
        <a
          className='text-mi-bg-primary text-sm flex items-center justify-center'
          href='https://mitene.us/digital_photo_frame/manual'
          target='_blank'
          rel='noreferrer noopener'
        >
          <OpenInNewIcon className='w-5 h-5 inline-block mr-1' />
          WEB版 取扱説明書
        </a>
      </div>
    </footer>
  )
}
